import { apiClient } from './client';

export interface Notification {
  id: number;
  user_id: number;
  type: string;
  title: string;
  message: string;
  link: string | null;
  is_read: number;
  created_at: string;
}

export const notificationsApi = {
  mine: () => apiClient.get<{ data: Notification[]; unreadCount: number }>('/api/notifications/mine'),
  markRead: (id: number) => apiClient.patch<{ data: { id: number; is_read: boolean } }>(`/api/notifications/${id}/read`),
};
